import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import SignUpPage from "./modules/SignUpPage/SignUpPage";
import SerpResultPage from "./modules/SerpResultPage/SerpResultPage";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import NavBarTop from "./modules/NavBarTop/NavBarTop";
import LoginPage from "./modules/LoginPage/LoginPage";
import DashboardPage from "./modules/DashboardPage/DashboardPage";
import FreeSerpChecker from "./modules/FreeSerpChecker/FreeSerpChecker";
import VerifyEmailPage from "./modules/VerifyEmailPage/VerifyEmailPage";
import TitleAndMetaCheckerPage from "./modules/TitleAndMetaCheckerPage/TitleAndMetaCheckerPage";
import OrderNotSuccessfullPage from "./modules/DashboardPage/OrderNotSuccessfullPage";
import InputNewPasswordPage from "./modules/PasswordResetPages/InputNewPasswordPage";
import RequestNewPasswordPage from "./modules/PasswordResetPages/RequestNewPasswordPage";
import PasswordResetRedirectPage from "./modules/PasswordResetPages/PasswordResetRedirectPage";
import TagManager from "react-gtm-module";
import PrivacyPolicyPage from "./modules/PrivacyPolicyandTermsPages/PrivacyPolicyPage";
import TermsPage from "./modules/PrivacyPolicyandTermsPages/TermsPage";
import TimelinePage from "./modules/TimelinePage/TimelinePage";
import Footer from "./modules/Footer/Footer";
import PricingPage from "./modules/PricingPage/PricingPage";
import OrderSuccessfullDaily10Page from "./modules/DashboardPage/OrderSuccessfull";
import OrderSuccessfullDaily60Page from "./modules/DashboardPage/OrderSuccessfullDaily60Page";
import OrderSuccessfullDaily250Page from "./modules/DashboardPage/OrderSuccessfullDaily250Page";
import FAQComponentPage from "./modules/FAQPage/FAQComponentPage";

import NewsletterSignUpPage from "./modules/NewsletterSignUpPage/NewsletterSignUpPage";
import HTagChecker from "./modules/HTagChecker/HTagChecker";
import ImageAltTextCheckerTopComponent from "./modules/ImageAltTextChecker/ImageAltTextCheckerTopComponent";
import Frontpage from "./modules/Frontpage/Frontpage";
import OnsiteScrapingPage from "./modules/OnSiteScrapingPage/OnSiteScrapingPage";
import SEOScorePieChart from "./modules/SEOScorePieChart/SEOScorePieChart";
import TestingPageNewDashboard from "./modules/TestingPage/TestingPageNewDashboard";
import ReportPageFromInsideApp from "./modules/reportPageFromInsideApp/ReportPageFromInsideApp";
import NewDashboard from "./modules/NewDashboard/NewDashboard";
import KeywordTrackingFromInsideApp from "./modules/KeywordTrackingFromInsideApp/KeywordTrackingFromInsideApp";
import OrderSuccessfullPage from "./modules/DashboardPage/OrderSuccessfull";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { renderToString } from "react-dom/server";
import QuickReportsPage from "./modules/QuickReportsPage/QuickReportsPage";
import MetaAndTitleCheckerPage from "./modules/MetaAndTitleCheckerPage/MetaAndTitleCheckerPage";
import SchemaTesterPage from "./modules/SchemaTesterPage/SchemaTesterPage";
import TestPage from "../src/modules/TestPage/TestPage.jsx";
import ReadonlyViewPage from "./modules/ReadonlyViewPage/ReadonlyViewPage";
import YourProfilePage from "./modules/YourProfilePage/YourProfilePage";
import NewSidebarAndHeaderTop from "./modules/NewSideBarAndHeaderTop/NewSidebarAndHeaderTop";
import DragAndDropDashboards from "./modules/DragAndDropDashboards/DragAndDropDashboards";
/* import { DndProvider } from "react-dnd"; */
import { HTML5Backend } from "react-dnd-html5-backend";

import { DndProvider } from "react-dnd-multi-backend";
import { HTML5toTouch } from "rdndmb-html5-to-touch";

function App() {
  //THIS IS FOR INITIALIZING GOOGLE TAG MANAGER:
  const tagManagerArgs = {
    gtmId: "GTM-TSGRS7Q",
  };

  TagManager.initialize(tagManagerArgs);

  const helmetContext = {};

  return (
    <DndProvider options={HTML5toTouch}>
      <HelmetProvider context={helmetContext}>
        <div>
          <BrowserRouter>
            <div className="overall-flex-wrapper">
              <Routes>
                <Route path="/" element={<LoginPage />} />;
                <Route path="/signup" element={<SignUpPage />} />;
                <Route path="/dashboard" element={<NewDashboard />} />
                <Route
                  path="/keyword-tracker"
                  element={<KeywordTrackingFromInsideApp />}
                />
                <Route
                  path="/dashboard/order/success" //THIS IS THE PAGE I REDIRECT TO ON ORDER SUCCESS.
                  element={<OrderSuccessfullPage />}
                />
                <Route
                  path="/users/dashboard/order/not-successfull"
                  element={<OrderNotSuccessfullPage />}
                />
                <Route path="/verify-email" element={<VerifyEmailPage />} />
                {/* THE BELOW 3 ARE FOR THE GENERATION OF A NEW PASSWORD */}
                <Route
                  path="/new-password"
                  element={<RequestNewPasswordPage />}
                />
                <Route
                  path="/password-reset"
                  element={<PasswordResetRedirectPage />}
                />
                <Route
                  path="/generate-new-password"
                  element={<InputNewPasswordPage />}
                />
                <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                <Route path="/terms" element={<TermsPage />} />
                <Route path="/report" element={<ReportPageFromInsideApp />} />
                <Route
                  path="/keyword-tracker"
                  element={<KeywordTrackingFromInsideApp />}
                />
                <Route path="/saved-reports" element={<QuickReportsPage />} />
                <Route
                  path="/meta-checker"
                  element={<MetaAndTitleCheckerPage />}
                />
                <Route
                  path="/schema-generator"
                  element={<SchemaTesterPage />}
                />
                <Route path="/test-page" element={<TestPage />} />
                <Route path="/view" element={<ReadonlyViewPage />} />
                <Route path="/profile" element={<YourProfilePage />} />
                <Route path="/testing23" element={<NewSidebarAndHeaderTop />} />
                <Route
                  path="/drag-and-drop-dashboard"
                  element={<DragAndDropDashboards />}
                />
              </Routes>
            </div>
          </BrowserRouter>
        </div>
      </HelmetProvider>
    </DndProvider>
  );
}

/* const html = renderToString(App); */ //NOT SURE IF THIS IS NEEDED

export default App;
